import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import { TableRow, Tooltip, IconButton, SvgIcon } from '@mui/material';
import AvatarTextField from 'src/components/widgets/avatar-textfield';
import PaginatedTable from 'src/components/ui/table/paginated-table';
import HeaderTableCell from 'src/components/ui/table/header-table-cell';
import TableCellText from 'src/components/ui/table/table-cell-text.js';
import { RouterLink } from 'src/components/router-link';
import UserEditIcon from 'src/icons/untitled-ui/free/user-edit';

export const ListTable = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    selected = [],
    onDetailClicked,
  } = props;

  const { t } = useTranslation();

  return (
    <PaginatedTable
      items={dataStore.items}
      loading={dataStore.loading}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      renderItem={(item, rowstyle) => (
        <TableRow hover selected={selected.includes(item.id)} sx={rowstyle}>
          <TableCellText>
              <AvatarTextField avatarSrc={item.avatar} avatarName={item.gender} value={item.name}
                onClick={() => onDetailClicked(item)} avatarSx={{ color: item.statusColor }} />
          </TableCellText>
          <TableCellText>{item.phone}</TableCellText>
          <TableCellText>{item.birthday}</TableCellText>
          <TableCellText>{item.courseName}</TableCellText>
          <TableCellText align='right'>{item.trackingName}</TableCellText>
          <TableCellText align='right'  sx={{ px: 0.5, textAlign: 'right', whiteSpace: 'normal'}}>
            <Tooltip title={'Sửa'}>
              <IconButton
                component={RouterLink}
                onClick={() => onDetailClicked(item)}
              >
                <SvgIcon>
                  <UserEditIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
          </TableCellText>
        </TableRow>
      )}
    >
      <TableRow>
        <HeaderTableCell sx={{ width: '30%' }}>{t(appStr.txt_002)}</HeaderTableCell>
        <HeaderTableCell sx={{ width: '15%' }}>Điện thoại</HeaderTableCell>
        <HeaderTableCell sx={{ width: '15%' }}>Sinh nhật</HeaderTableCell>
        <HeaderTableCell sx={{ width: '15%' }}>Hạng</HeaderTableCell>
        <HeaderTableCell sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}>Người liên hệ</HeaderTableCell>
        <HeaderTableCell sx={{ width: '24px', px: 0.5, textAlign: 'right', whiteSpace: 'nowrap' }} />
      </TableRow>
    </PaginatedTable>
  );
};

ListTable.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
